<template>
  <div class="text-centerz">
    <v-card :min-width="cardMinWidth" :max-width="cardMaxWidth" :style="{ height: cardHeight }" class="mx-auto" outlined>
      
      <!-- Flex Column Container -->
      <v-card-text class="d-flex flex-column justify-space-between " style="height: 100%;">
        
        <!-- Top Content -->
        
        <div >
          <v-row class="text-center">
            <v-col class="mb-2 display-2 font-weight-light pointer" @click="home">
              <span style="color: #50e3c2">taleem</span>
              <span class="font-weight-black" style="color: #383838">.app</span>
            </v-col>
          </v-row>

          <v-text-field v-model="code" outlined ref="locationCode" dense :error-messages="codeErrors" label="Code">
            <template v-slot:append>
              <v-btn small text @click="$router.push({ path: '/forgot' })">forgot</v-btn>
            </template>
          </v-text-field>

          <v-text-field v-model.trim="email" outlined dense :error-messages="emailErrors" label="Email">
          </v-text-field>

          <v-text-field v-model="password" outlined dense :append-icon="showPassword ? 'visibility_off' : 'visibility'"
            :type="showPassword ? 'text' : 'password'" :label="$t('labels.password')" v-on:keyup.enter="submit"
            :error-messages="passwordErrors" @input="$v.password.$touch()" counter="counter"
            @click:append="showPassword = !showPassword">
          </v-text-field>
        </div>

        <!-- Buttons Row -->
        <v-row no-gutters align="center" justify="center">
          <v-col cols="auto">
            <v-btn text color="secondary" @click="$router.push({ path: '/forgot' })">
              forgot password
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn :loading="loading" @click="submit" color="primary">
              {{ $t("buttons.login") }}
            </v-btn>
          </v-col>
        </v-row>

       <!-- <v-divider> </v-divider>
      <v-card-actions>
        <v-btn color="secondary" @click="$router.push({ path: '/signup' })" text block>Don't have an Account?</v-btn>
      </v-card-actions> -->
      </v-card-text>

    </v-card>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import authService from "../service";
// import GoogleLogin from "./GoogleLogin";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      showPassword: false,
      email: null,
      loading: false,
      password: null,
      code: null,
    };
  },
  created() {
    const localStoreCode = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
    if (localStoreCode) {
      this.code = localStoreCode;
    }
    // console.log("created in login", this.code);

  },
  methods: {
    ...mapActions("global", ["initBusiness", "initUser"]),
    submitLocation() {
      console.log('submitLocation', this.code)
    },
    home() {
      window.open("https://taleem.com", "_self");
    },
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Invalid User",
          });
      } else {
        // this.initUser()
        localStorage.setItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}code`,
          this.code
        );
        // console.log('tesetd', response.user)
        if (response.user.userType === 'teacher') {
          this.$router.push({ name: "thome" });
          // return false
        } 
        else {
          this.$router.push({ name: "home" });
          // return false
        }

      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.$Progress.start();
        authService
          .authenticate({
            email: this.email,
            password: this.password,
            code: this.code,
          })
          .then((response) => {
            this.$Progress.finish();
            // console.log('response after login', response)
            this.checkResponse(response);
            this.loading = false;
          })
          .catch((error) => {
            this.$Progress.finish();
            this.loading = false;
            console.log("error on ", error);
            this.$swal("Invalid Login", error.data.message, "error");
          });
      }
    },
  },
  computed: {
    codeErrors() {
      const errors = [];
      if (!this.$v.code.$dirty) return errors;
      if (!this.$v.code.required) errors.push("Code is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    },
    // Adjusting the logic to target specific device widths
    cardMinWidth() {
      const screenWidth = this.$vuetify.breakpoint.width;
      // Check if the width is within a range that includes iPad Pro and Surface Pro 7
      if ((screenWidth >= 1024 && screenWidth <= 1366) || (screenWidth >= 1824 && screenWidth <= 2736)) {
        return '600';
      }
      return '300';
    },
    cardMaxWidth() {
      const screenWidth = this.$vuetify.breakpoint.width;
      // Same range-based logic as cardMinWidth
      if ((screenWidth >= 1024 && screenWidth <= 1366) || (screenWidth >= 1824 && screenWidth <= 2736)) {
        return '500';
      }
      return '350';
    },
    cardHeight() {
      const screenWidth = this.$vuetify.breakpoint.width;
      if ((screenWidth >= 1024 && screenWidth <= 1366) || (screenWidth >= 1824 && screenWidth <= 2736)) {
        return '400px'; // Set this to the desired height for iPad Pro and Surface Pro 7
      }
      return 'auto'; // Default height for other devices
    },
    
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
    code: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>